module.exports = __webpack_public_path__ + "static/img/swiper10.e46e6b7d.png";